module.exports = __webpack_public_path__ + "img/logo_lab.90d1b781.png";